import { createServerErrorMessage } from '../../../../../Helpers/FormInputHelper';
import { ServiceClient } from '../../../../../Services/ServiceClient';
import { teamPageReducerTypes } from '../../../Reducer';

export const onSubmit = (event, agentCode, team, dispatch, setError) => {
  event.preventDefault();

  ServiceClient.setDefaultAgentCodeForTeam(
    agentCode,
    team.codePrefix,
    data => {
      if (data) {
        updateDefaultAgentCode(team, dispatch, agentCode);
      }
    },
    error => {
      setError(createServerErrorMessage(error).message);
    }
  );
};

const updateDefaultAgentCode = (team, teamPageDispatch, agentCode) => {
  const newAgents = [];
  team.agents.forEach(agent => {
    if (agent.isDefaultAgentCode) {
      agent.isDefaultAgentCode = false;
    }
    if (agent.code === agentCode) {
      agent.isDefaultAgentCode = true;
    }
    newAgents.push(agent);
  });
  teamPageDispatch({
    type: teamPageReducerTypes.setDefaultAgent,
    payload: { ...team, agents: newAgents },
  });
};
